import { render, staticRenderFns } from "./RiskStoryDetailsModal.vue?vue&type=template&id=0755e9a0&scoped=true&"
import script from "./RiskStoryDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./RiskStoryDetailsModal.vue?vue&type=script&lang=ts&"
import style0 from "./RiskStoryDetailsModal.vue?vue&type=style&index=0&id=0755e9a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0755e9a0",
  null
  
)

export default component.exports